import React, {useEffect, useRef, useState} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import Dropdown from "../FormComponents/Dropdown/Dropdown";
import Checkbox from "../FormComponents/Checkbox/Checkbox";


const Options = ({title, name, items, type, required, requiredMessage, hidden, id}) => {
    const [autoFill, setAutoFill] = useState(false);
    const [showOptions, setShowOptions] = useState(!hidden);
    const [input, setInput] = useState("");
    const inputRef = useRef(null);
    const searchParams = new URLSearchParams(window.location.search);
    const showFieldMapper = items.filter(i => i.showField);

    useEffect(() => {
        if(searchParams.get('submit') && !!sessionStorage.getItem(name)) {
            setAutoFill(true);
        }
        let select = inputRef.current;
        if(select){
            select.addEventListener('change', function() {
                if(select.checkValidity) select.classList.remove("error");
            });
        }

    }, [window.location.search]);

    useEffect(() => {
        if(inputRef.current){
            let select = inputRef.current;
            for (let i = 0; i < showFieldMapper.length; i++) {
                let showFieldItem = showFieldMapper[i];
                let divField = document.getElementById(`div-options-${showFieldItem.showField}`);
                let field = document.getElementById(`${showFieldItem.showField}`);
                if(field){
                    if(select.value === showFieldItem.value){
                        field.removeAttribute('disabled');
                        divField.style.display = 'block';
                    } else {
                        field.setAttribute('disabled', "disabled");
                        divField.style.display = 'none';
                    }
                }
            }
        }
    }, [input])

    const getFromStorage = (key) => {
        if(!autoFill) return;
        return sessionStorage.getItem(key) != null ? sessionStorage.getItem(key) : "";
    }

    return (
        <div id={`div-options-${id}`} style={{display: hidden ? 'none' : 'block'}}>
            {type === 'CHECKBOX' ?
                items.map(({value, text}) =>
                    (<Checkbox
                        name={name}
                        value={value}
                        labelText={`<p>${text}</p>`}
                    />)
                )
                :
                <Dropdown
                    id={id}
                    disabled={hidden}
                    labelText={title}
                    required={required}
                    errorMessage={requiredMessage}
                    name={name}
                    useLabelAsValue={false}
                    value={getFromStorage(name)}
                    validate={setInput}
                    options={items.map((country) => ({label: country.text, value: country.value}))}
                    inputRef={inputRef}
                />
            }
        </div>
    )
}

const OptionsErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>This component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <Options {...props}/>
        </ErrorBoundary>
    )
}


export default OptionsErrors;